const moment = require('moment');
const defaultState = {
    fi: [],
    fiDetail: {},
    loading: false,
    loadingHist: false,
    errors:{},
    lastFiltersFI:[],
    fiHist:[]
  }
  
export default (state=defaultState, action={}) => {
    switch (action.type) {

      case 'FETCH_FI_FULFILLED': {
        let arrayMain=[];
        let newItem = {};
        let indipsMode = '';
        
        if(Array.isArray(action.payload.data)){
            action.payload.data.forEach((element,index) => {
            newItem = {};
            newItem = element;//limpa para criar um novo
            indipsMode = element.FLAG_GB === 1 ? 'GB ' : '';
            indipsMode = element.FLAG_T === 1 ? indipsMode + 'T ' : indipsMode + '';
            indipsMode = element.FLAG_C === 1 ? indipsMode + 'C' : indipsMode + '';
            newItem["indispMode"] = indipsMode;
            newItem["BEGIN_DATETIME_LOCAL"] = moment.utc(element.BEGIN_DATETIME, 'YYYY-MM-DD HH:mm').tz(element.TIMEZONE).format('YYYY-MM-DD HH:mm');
            newItem["END_DATETIME_LOCAL"] = moment.utc(element.END_DATETIME, 'YYYY-MM-DD HH:mm').tz(element.TIMEZONE).format('YYYY-MM-DD HH:mm');

            //fazer set de state destes valores como auxiliares para criar valdiações
            arrayMain.push(newItem);
            });
        }else{
            console.log('FETCH_FI_FULFILLED error: ');
            console.dir(action.payload.data);
        }
        
        return {
          ...state,
          fi: arrayMain,
          loading: false,
          errors: {}
        }
      }
  
      case 'FETCH_FI_PENDING': {
        return {
          ...state,
          loading: true,
          errors: {}
        }
      }
  
      case 'FETCH_FI_REJECTED': {
        return {
          ...state,
          loading: false,
          errors: { global: action.payload.message }
        }
      }
  
      case 'FETCH_FI_DETAIL_FULFILLED': {
    
        const id = action.payload.data[0].ID;
        const status = action.payload.data[0].STATUS;
        
        return {
          ...state,
          fiDetail: action.payload.data[0],
          fi: state.fi.map(item => item.ID === id ? {...item, STATUS: status} : item),
          errors: {},
          loadingHist: false
        }
      }

      case 'FETCH_FI_DETAIL_PENDING': {
        return {
          ...state,
          loadingHist: true,
          fiDetail: {},
          errors: {}
        }
      }
      
      case 'FETCH_FI_DETAIL_REJECTED': {
        return {
          ...state,
          loadingHist: false,
          errors: { global: action.payload.message }
        }
      }      

      case 'LASTFILTER_FI': {      
        return {
          ...state,
          lastFiltersFI: action.payload
        }
      }

      case 'FETCH_FI_HISTORY_FULFILLED': {
        return {
          ...state,
          fiHist: action.payload.data,
          loadingHist: false,
          errors: {}
        }
      }
  
      case 'FETCH_FI_HISTORY_PENDING': {
        return {
          ...state,
          loadingHist: true,
          errors: {}
        }
      }
  
      case 'FETCH_FI_HISTORY_REJECTED': {
        return {
          ...state,
          loadingHist: false,
          errors: { global: action.payload.message }
        }
      }       

      case 'EDIT_FI_FULFILLED': {

        const id = action.editedRecord.ID;
        const auxEditedRecord = action.editedRecord;
        let indipsMode =  auxEditedRecord.FLAG_GB === 1 ? 'GB ' : '';
        indipsMode = auxEditedRecord.FLAG_T === 1 ? indipsMode + 'T ' : indipsMode + '';
        indipsMode = auxEditedRecord.FLAG_C === 1 ? indipsMode + 'C' : indipsMode + '';
        auxEditedRecord["indispMode"] = indipsMode;     
        return {
            ...state,
            fi: state.fi.map(item => item.ID === id 
              ? auxEditedRecord 
              : item
              )
        }
      }

      default:
        return state;
    }
  }



// WEBPACK FOOTER //
// ./src/reducers/fi-reducer.js